var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.92314 1.62565C9.84223 1.5502 9.71548 1.55463 9.64004 1.63553L1.76292 10.0827L1.61672 12.7023L4.21972 12.3737L12.0968 3.92654C12.1723 3.84563 12.1679 3.71888 12.087 3.64344L9.92314 1.62565ZM8.49048 0.563547C9.15796 -0.152244 10.2793 -0.191403 10.9951 0.476083L13.1589 2.49388C13.8747 3.16136 13.9139 4.28273 13.2464 4.99852L5.29699 13.5232C5.09293 13.7421 4.81861 13.8824 4.52175 13.9199L0.995313 14.365C0.510643 14.4262 0.0681442 14.0829 0.00696404 13.5982C0.000264197 13.5452 -0.00160676 13.4916 0.0013744 13.4382L0.199442 9.88927C0.216116 9.59053 0.336999 9.30708 0.54106 9.08825L8.49048 0.563547Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.99 6.2656L7.38361 2.90261L8.0562 2.18134L11.6626 5.54433L10.99 6.2656Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5746 16.5042H0.785915C0.351866 16.5042 0 16.8561 0 17.2901C0 17.7242 0.351866 18.076 0.785915 18.076H12.5746C13.0087 18.076 13.3605 17.7242 13.3605 17.2901C13.3605 16.8561 13.0087 16.5042 12.5746 16.5042Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditWhite);
export default __webpack_public_path__ + "static/media/edit-white.fa4e19dd4359f80478fdbd44bee1a45e.svg";
export { ForwardRef as ReactComponent };